import Reveal from "@/components/Reveal";
import { STEPS } from "@/constants/content";

export default function Process() {
  return (
    <section id="process" className="relative py-20 sm:py-28" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="eyebrow text-brandsky-deep">How it works</p>
          <h2 className="font-display mt-3 max-w-2xl text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-[2.75rem] lg:leading-[1.05]">
            From broken to back in service, in four steps.
          </h2>
        </Reveal>

        <div className="relative mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-10 hidden h-px bg-gradient-to-r from-transparent via-brandsky/50 to-transparent lg:block" />
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="group relative h-full rounded-[22px] border border-ink/10 bg-white p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(22,50,79,0.12)]" data-testid={`process-step-${s.n}`}>
                <div className="font-mono flex h-12 w-12 items-center justify-center rounded-2xl bg-ink text-[15px] font-bold text-white shadow-[0_10px_24px_rgba(22,50,79,0.25)]">
                  {s.n}
                </div>
                <h3 className="font-display mt-5 text-lg font-bold text-ink">{s.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-slate-600">{s.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}